import { setValueValue } from '@databases/collab/y-database';
import { type MutableEntry } from '@databases/model/entry';
import { type FieldType } from '@databases/model/field';
import { type AllValueJSON, type MutableValue } from '@databases/model/value';

export function getOrSetValue<T extends FieldType>(
  entry: MutableEntry,
  fieldId: string,
  type: T,
  defaultValue?: AllValueJSON
): MutableValue<T> {
  const value = entry.getValue(fieldId);

  if (value && value.type === type) {
    return value as MutableValue<T>;
  } else {
    const newValue = entry.setValue(fieldId, type);

    if (defaultValue) {
      setValueValue(newValue, defaultValue);
    }

    return newValue;
  }
}
